import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getBundle = (bundle) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_BUNDLE, {
    params: {
      BundleId: bundle.bundleId,
      BundleName: bundle.bundleName,
      OrderByColumn: bundle.orderByColumn,
      SortDir: bundle.sortByDesc,
      isActive: bundle.isActive,
      PageSize: bundle.pageSize,
      PageNumber: bundle.pageNumber,
      SubjectId: bundle.subjectId,
      ContentAreaId: bundle.contentAreaId,
      StateId: bundle.stateId,
      GradeId: bundle.gradeId,
      GradeLevelId: bundle.gradeLevelId,
      isAlaCarte: bundle.isAlaCarte,
    },
  });
};

export const getAllBundlesBySchoolId = (SchoolId: number) => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_BUNDLE_SCHOOL}`, {
    params: {
      SchoolId: SchoolId,
    },
  });
};

export const getBundleById = (id: number) => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_BUNDLE}/${id}`, {});
};

export const postBundle = (bundle) => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_BUNDLE, bundle, {});
};

export const copyBundle = (userId: number, bundleId: number) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_COPY_BUNDLE,
    {
      userId: userId,
      bundleId: bundleId,
    },
    {}
  );
};

export const updateBundle = (bundle) => {
  return AxiosHelper.axiosInstance().put(APIConstant.CMS_BUNDLE, bundle, {});
};
export const updateBundleExtendedDate = (bundle) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_BUNDLE_EXTENDED_DATE,
    bundle,
    {}
  );
};
export const deleteBundle = (bundle) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_BUNDLE, {
    params: {
      bundleId: bundle.bundleId,
    },
  });
};

export const postBundleSellableProduct = (bundleSellableProduct) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_BUNDLESELLEABLESUBJECT,
    bundleSellableProduct,
    {}
  );
};

export const getBundleSellableSubject = (bundleSellableId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_BUNDLESELLEABLESUBJECT,
    {
      params: {
        sellableProductId: bundleSellableId,
      },
    }
  );
};

export const getBundleProduct = (bundleId: number) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_BUNDLE_SELLABLE_PRODUCT,
    {
      params: {
        bundleId: bundleId,
      },
    }
  );
};

export const postBundleProduct = (bundleId: number, productIds: string) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_BUNDLE_SELLABLE_PRODUCT,
    {
      bundleId: parseInt(bundleId.toString()),
      sellableProductIds: productIds,
    }
  );
};

export const deleteBundleProduct = (bundleId: number, productId: number) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_BUNDLE_SELLABLE_PRODUCT,
    {
      params: {
        bundleId: bundleId,
        sellableProductId: productId,
      },
    }
  );
};

export const updateBundleExtendedDateAll = (
  schoolId: number,
  extendEndDate: string
) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_BUNDLE_EXTENDED_DATE_ALL,
    {
      schoolId: schoolId,
      extendedEndDate: extendEndDate,
    },
    {}
  );
};
